// extracted by mini-css-extract-plugin
export default {"details":"BetDetails_details__U42rd","finance":"BetDetails_finance__bBXei","finance__item":"BetDetails_finance__item__D1gpM","finance__value":"BetDetails_finance__value__gxq83"};